import { connect } from 'react-redux';
import QRCodeReaction from '../components/OrderDashboardPages/pages/QRCodeReaction';
import { getPersonQrCodeStatus } from '../redux/actions/CurrentPersonStatus';
import { getUser as getUserSelector } from '../redux/selectors/accountSettingSelector';
import { getUser } from '../redux/actions/AccountSetting';
import { goBack, push } from "react-router-redux";

const mapStateToProps = (state) => ({
  user: getUserSelector(state),
  isLoading: state.currentPersonStatus.isLoadingQrCode,
  list: state.currentPersonStatus.qrCodeList,
  pageInfo: state.currentPersonStatus.pageInfoQrCode,
})

const mapDispatchToProps = dispatch => ({
  getPersonQrCodeStatus(data, overwrite) {
    dispatch(getPersonQrCodeStatus(data, overwrite))
  },

  getUserInfo() {
    dispatch(getUser());
  },

  goBack() {
    dispatch(goBack());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(QRCodeReaction);



// WEBPACK FOOTER //
// ./src/containers/QRCodeReaction.js